import { Field } from 'react-final-form'
import AutosuggestInput from '../AutosuggestInput'

export default function FormAutosuggest(props) {
  const { name } = props
  return <Field name={name} component={AutosuggestInput} {...props} />
}
